import React from 'react';
import { Hero } from './components/Hero';
import { HiddenKnowledge } from './components/HiddenKnowledge';
import { PainAndHope } from './components/PainAndHope';
import { PowerShift } from './components/PowerShift';
import { Visualization } from './components/Visualization';
import { Opportunity } from './components/Opportunity';
import { SocialProof } from './components/SocialProof';
import { FuturePacing } from './components/FuturePacing';
import { FinalCTA } from './components/FinalCTA';
import { FloatingCTA } from './components/FloatingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-dark overflow-x-hidden" data-id="element-0">
      <Hero data-id="element-1" />
      <HiddenKnowledge data-id="element-2" />
      <PainAndHope data-id="element-3" />
      <PowerShift data-id="element-4" />
      <Visualization data-id="element-5" />
      <Opportunity data-id="element-6" />
      <SocialProof data-id="element-7" />
      <FuturePacing data-id="element-8" />
      <FinalCTA data-id="element-9" />
      <Footer data-id="element-10" />
      <FloatingCTA data-id="element-11" />
    </div>;
}